import React, { useEffect } from "react";
import SignOnchat from "../../components/signon/signonchat.index";
import SignOnlogo from "../../components/signon/signon.index";
import Footerlogo from "../../components/signon/footerlogo.index";
import "./signon.style.css";
import { Layout } from "antd";
import Header from "../../components/Header";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../components/msalAuth/AuthProvider";
import Loader from "../../components/configure/Loader";
import { isValidRedirectPath } from "../../components/configure/utils";

const { Content } = Layout;

const SignOn = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  // const hasNavigatedRef = useRef(false); // This ref used to prevent double navigation in Strict Mode

  useEffect(() => {
    const storedPath = sessionStorage.getItem("wk_redirect");
    if (isAuthenticated && storedPath && isValidRedirectPath(storedPath) && location.pathname !== "/walkincenter") {
      // sessionStorage.removeItem("wk_redirect");
      navigate(storedPath, { replace: true });
    } else if (isAuthenticated && location.pathname !== "/homepage") {
      // hasNavigatedRef.current = true;
      navigate("/homepage", { replace: true });
    }
  }, [isAuthenticated, location, navigate]);

  // useEffect(() => {
  //   if (isAuthenticated) {
  //     navigate("/", { replace: true });
  //   }
  // }, [isAuthenticated, navigate]);

  if (isAuthenticated) {
    return <Loader message="Loading..." />;
  }

  return (
    <Layout className="sgn-sandee-layout">
      <Header />
      <div className="sgn-background-shapes">
        <div className="sgn-shape sgn-shape-1"></div>
        <div className="sgn-shape sgn-shape-2"></div>
        <div className="sgn-shape sgn-shape-3"></div>
      </div>

      <Content className="sgn-sandee-content">
        <div className="sgn-main-wrapper">
          <SignOnlogo />
          <SignOnchat />
        </div>
        <Footerlogo />
      </Content>
    </Layout>
  );
};

export default SignOn;
